import styled from 'styled-components';
import * as colors from '../../config/colors';

const COLLAPSE_MS = '220ms';
const EASE = 'cubic-bezier(0.2, 0, 0, 1)';

export const Nav = styled.nav`
   position: relative;
   top: auto;
   left: auto;

   height: 100%;
   width: 100%;
   min-width: 0;

   background-color: white;
   min-height: 100%;
   padding: 0 12px;
   display: flex;
   flex-direction: column;
   overflow-y: auto;

   /* Scrollbar do nav */
   ::-webkit-scrollbar { width: 8px; }
   ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
   ::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
   ::-webkit-scrollbar-thumb:hover { background: #555; }

   /* ─── Layout interno ─── */

   .nav-top { flex-shrink: 0; }

   .nav-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: start;
      overflow-y: hidden;
      min-height: 0;
   }

   .nav-bottom {
      flex-shrink: 0;
      padding-bottom: 12px;
   }

   /* ─── Label de seção ─── */
   h3 {
      text-align: left;
      margin-bottom: 6px;
      margin-top: 12px;
      padding: 0 4px 8px;
      font-weight: 600;
      font-size: 0.7rem;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #9ca3af;
      background-color: transparent;
      border-bottom: 1px solid #f3f4f6;
      flex-shrink: 0;
   }

   /* ─── Menu items container ─── */
   .menu-items {
      display: flex;
      flex-direction: column;
      gap: 2px;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      flex: 1;
      padding-right: 2px;
   }

   .menu-items::-webkit-scrollbar { width: 4px; }
   .menu-items::-webkit-scrollbar-track { background: transparent; }
   .menu-items::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }
   .menu-items::-webkit-scrollbar-thumb:hover { background: #9ca3af; }

   /* ─── Link principal ─── */
   .menu-link {
      position: relative;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 10px;
      border-radius: 8px;
      color: ${colors.primaryDarkColor};
      font-weight: 500;
      font-size: 0.8rem;
      transition: background 180ms ${EASE}, border-color 180ms ${EASE};
      text-decoration: none;
      border: 1px solid transparent;
      background-color: transparent;

      &:hover {
         background-color: #f3f4f6;
         border-color: #e5e7eb;
      }

      &.active {
         background: linear-gradient(90deg, ${colors.primaryDarkColor}15 0%, ${colors.primaryDarkColor}08 100%);
         border-color: ${colors.primaryDarkColor}40;
         color: ${colors.primaryDarkColor};
         font-weight: 600;

         .menu-icon {
            color: ${colors.primaryDarkColor};
            background-color: ${colors.primaryDarkColor}20;
         }
      }
   }

   .menu-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 8px;
      background-color: #f9fafb;
      color: ${colors.primaryDarkColor};
      flex-shrink: 0;
      transition: background 180ms ${EASE}, color 180ms ${EASE};
   }

   .menu-label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .active-indicator {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: ${colors.primaryDarkColor};
      flex-shrink: 0;
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
   }

   @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.4; }
   }

   /* ─── Grupo de menus ─── */
   .menu-group {
      display: flex;
      flex-direction: column;
      width: 100%;
      position: relative; /* ancora o popover */
   }

   .menu-group-btn {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 10px;
      border: 1px solid transparent;
      border-radius: 8px;
      background-color: transparent;
      color: ${colors.primaryDarkColor};
      font-weight: 500;
      font-size: 0.8rem;
      cursor: pointer;
      transition: background 180ms ${EASE}, border-color 180ms ${EASE};
      text-align: left;

      &:hover {
         background-color: #f3f4f6;
         border-color: #e5e7eb;
         .menu-icon { background-color: ${colors.primaryDarkColor}10; }
      }

      &.open {
         background-color: #f9fafb;
         border-color: #e5e7eb;
         .menu-chevron { color: ${colors.primaryDarkColor}; }
      }

      &.has-active {
         border-color: ${colors.primaryDarkColor}20;
         .menu-icon {
            background-color: ${colors.primaryDarkColor}15;
            color: ${colors.primaryDarkColor};
         }
      }
   }

   .menu-chevron {
      margin-left: auto;
      display: flex;
      align-items: center;
      color: #9ca3af;
      transition: transform 280ms ${EASE}, color 180ms ${EASE};
      &.rotate { transform: rotate(90deg); }
   }

   /* ─── Submenu (expandido) ─── */
   .submenu-wrapper {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 300ms cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;
   }

   .submenu-wrapper.open { grid-template-rows: 1fr; }

   .submenu {
      min-height: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
      padding-top: 4px;
      padding-left: 14px;
      border-left: 2px solid #e5e7eb;
   }

   .submenu-link {
      position: relative;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 7px 10px;
      border-radius: 6px;
      color: #6b7280;
      font-size: 0.75rem;
      font-weight: 500;
      text-decoration: none;
      transition: background 150ms ${EASE}, color 150ms ${EASE}, border-color 150ms ${EASE};
      border: 1px solid transparent;

      &:hover {
         background-color: #f9fafb;
         color: ${colors.primaryDarkColor};
         border-color: #e5e7eb;
         .submenu-icon {
            color: ${colors.primaryDarkColor};
            background-color: ${colors.primaryDarkColor}10;
         }
      }

      &.active {
         background-color: ${colors.primaryDarkColor}08;
         color: ${colors.primaryDarkColor};
         font-weight: 600;
         border-color: ${colors.primaryDarkColor}30;
         .submenu-icon {
            background-color: ${colors.primaryDarkColor}20;
            color: ${colors.primaryDarkColor};
         }
      }
   }

   .submenu-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 6px;
      background-color: #f3f4f6;
      color: #6b7280;
      flex-shrink: 0;
      transition: background 180ms ${EASE}, color 180ms ${EASE};
   }

   .submenu-label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .new-badge {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      padding: 2px 7px;
      border-radius: 999px;
      background: #10b981;
      color: #fff;
      font-size: 0.6rem;
      font-weight: 700;
      letter-spacing: 0.02em;
      line-height: 1;
   }

   /* ─── Group popover (collapsed) ─── */
   /* Mesmo padrão visual do module-popover */
   .group-popover {
      position: absolute;
      left: calc(100% + 10px);
      top: 0;
      z-index: 9999;
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 6px 0;
      min-width: 192px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
   }

   .group-popover-title {
      font-size: 0.65rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #9ca3af;
      margin: 0 0 4px;
      padding: 0 14px;
   }

   .group-popover-item {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      background: none;
      border: none;
      color: #374151;
      font-size: 0.8rem;
      padding: 8px 14px;
      cursor: pointer;
      text-align: left;
      font-weight: 500;
      transition: background 140ms ${EASE}, color 140ms ${EASE};
      text-decoration: none;

      &:hover {
         background: #f9fafb;
         color: ${colors.primaryDarkColor};
         .group-popover-icon {
            background-color: ${colors.primaryDarkColor}10;
            color: ${colors.primaryDarkColor};
         }
      }

      &.active {
         color: ${colors.primaryDarkColor};
         font-weight: 600;
         .group-popover-icon {
            background-color: ${colors.primaryDarkColor}20;
            color: ${colors.primaryDarkColor};
         }
      }
   }

   .group-popover-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 6px;
      background-color: #f3f4f6;
      color: #6b7280;
      flex-shrink: 0;
      transition: background 180ms ${EASE}, color 180ms ${EASE};
   }

   .group-popover-active-dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: ${colors.primaryDarkColor};
      margin-left: auto;
      flex-shrink: 0;
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
   }

   /* ─── Botão colapsar ─── */
   .collapse-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      background: transparent;
      color: #9ca3af;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 8px 12px;
      cursor: pointer;
      font-weight: 500;
      font-size: 0.75rem;
      transition: background 180ms ${EASE}, border-color 180ms ${EASE}, color 180ms ${EASE};
      margin-top: 8px;
      white-space: nowrap;
      overflow: hidden;

      &:hover {
         background-color: #f3f4f6;
         border-color: ${colors.primaryDarkColor}30;
         color: ${colors.primaryDarkColor};
      }

      svg { flex-shrink: 0; }
   }

   /* ─── Configurações fixas no bottom ─── */
   .settings-fixed {
      display: flex;
      flex-direction: column;
      gap: 2px;
      padding-top: 8px;
      border-top: 1px solid #f3f4f6;
      margin-top: 8px;
      flex-shrink: 0;
   }

   /* ─── Home fixa (acima do seletor de módulo) ───
      Entrada fixa, sem RBAC e independente do módulo ativo. Espelha o
      tratamento do .settings-fixed, mas ancorada no topo. */
   .home-fixed {
      display: flex;
      flex-direction: column;
      padding-top: 4px;
      flex-shrink: 0;
   }

   /* ─── Seletor de módulo (expandido) ─── */
   .module-selector-wrapper {
      padding: 10px 2px 12px;
      border-bottom: 1px solid #f3f4f6;
      margin-bottom: 6px;
   }

   .module-selector-label {
      font-size: 0.65rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #9ca3af;
      margin: 0 0 6px;
      padding: 0 2px;
   }

   .module-select {
      width: 100%;
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      color: ${colors.primaryDarkColor};
      font-size: 0.8rem;
      padding: 8px 32px 8px 10px;
      cursor: pointer;
      outline: none;
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 10px center;
      transition: border-color 180ms ${EASE}, background 180ms ${EASE};
      font-weight: 500;

      &:hover { border-color: ${colors.primaryDarkColor}40; background-color: #f3f4f6; }
      &:focus { border-color: ${colors.primaryDarkColor}60; outline: none; }
      option { background: #fff; color: ${colors.primaryDarkColor}; }
   }

   .module-badge {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.7rem;
      color: #9ca3af;
      margin-top: 6px;
      cursor: pointer;
      transition: color 180ms ${EASE};
      user-select: none;
      padding: 0 2px;

      &:hover { color: ${colors.primaryDarkColor}; }

      .dot {
         width: 6px;
         height: 6px;
         border-radius: 50%;
         background: #34d399;
         flex-shrink: 0;
      }
   }

   /* ─── Popover de módulo (collapsed) ─── */
   .module-popover-wrapper {
      position: relative;
      padding: 8px 0 4px;
      flex-shrink: 0;
   }

   .module-popover-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      color: #6b7280;
      padding: 8px 0;
      cursor: pointer;
      transition: background 180ms ${EASE}, color 180ms ${EASE}, border-color 180ms ${EASE};

      &:hover {
         background: #f3f4f6;
         color: ${colors.primaryDarkColor};
         border-color: ${colors.primaryDarkColor}30;
      }
   }

   .module-popover {
      position: absolute;
      left: calc(100% + 10px);
      top: 8px;
      z-index: 9999;
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 6px 0;
      min-width: 176px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
   }

   .module-popover-title {
      font-size: 0.65rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #9ca3af;
      margin: 0 0 4px;
      padding: 0 14px;
   }

   .module-popover-item {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      background: none;
      border: none;
      color: #374151;
      font-size: 0.8rem;
      padding: 8px 14px;
      cursor: pointer;
      text-align: left;
      transition: background 140ms ${EASE};
      font-weight: 500;

      &:hover { background: #f9fafb; }
      &.active { color: ${colors.primaryDarkColor}; font-weight: 600; }

      .active-dot {
         width: 6px;
         height: 6px;
         border-radius: 50%;
         background: #34d399;
         margin-left: auto;
         flex-shrink: 0;
      }
   }

   /* ─── Estado colapsado ─── */
   ${(p) =>
      p.$collapsed &&
      `
      padding: 0 8px;

      h3 { display: none; }

      .module-selector-wrapper { display: none; }

      .menu-items { padding-right: 0; }

      .menu-link,
      .menu-group-btn {
         justify-content: center;
         padding: 9px;

         .menu-icon { margin: 0; }
         .menu-label,
         .menu-chevron,
         .active-indicator { display: none; }
      }

      .submenu-wrapper { display: none; }

      .menu-link.active {
         background-color: ${colors.primaryDarkColor}12;
         border-color: ${colors.primaryDarkColor}40;
         .menu-icon { background-color: ${colors.primaryDarkColor}25; }
      }

      .settings-fixed {
         border-top: 1px solid #f3f4f6;
         padding-top: 8px;
         margin-top: 4px;
      }

      .home-fixed {
         border-bottom: 1px solid #f3f4f6;
         padding-bottom: 8px;
         margin-bottom: 4px;
      }

      .collapse-btn {
         padding: 9px;
         justify-content: center;
         span { display: none; }
      }
   `}

   /* ─── Mobile ─── */
   @media (max-width: 900px) {
      .collapse-btn { display: none; }
      .module-popover-btn { display: none; }

      height: 100vh;
      height: 100dvh;
      max-height: 100vh;
      max-height: 100dvh;

      .nav-content {
         max-height: calc(100vh - 160px);
         max-height: calc(100dvh - 160px);
         -webkit-overflow-scrolling: touch;
      }
   }

   transition: padding ${COLLAPSE_MS} ${EASE};
`;

export const LogoNav = styled.div``;
